module.exports = __webpack_public_path__ + "media/images/mobile/solutions/0-48048f4d85eca57cddc73c505f1f91da.jpg";